import React, { useEffect, useState } from "react";
import axios from "axios";
import "@fontsource/chivo";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import { FaFilePdf } from "react-icons/fa";



const ITEMS_PER_PAGE = 10;

const OrdiniTable = () => {
  const [orders, setOrders] = useState([]);
  const [filtered, setFiltered] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [filterPosto, setFilterPosto] = useState("");
  const [filterDate, setFilterDate] = useState("");


  const exportToPDF = () => {
    const doc = new jsPDF();
  
    doc.setFont("helvetica", "bold");
    doc.text("Elenco Posti/Email/Telefono", 14, 15);
    doc.setFont("helvetica", "normal");
  
    const rows = filtered.map((order) => [
      order.id,
      order.posto,
      order.email || "—",
      order.phone || "—",
      new Date(order.created_at).toLocaleString("it-IT", {
        timeZone: "Europe/Rome",
      }),
    ]);
  
    autoTable(doc, {
      startY: 20,
      head: [["ID", "Posto", "Email", "Telefono", "Creato"]],
      body: rows,
      styles: { font: "helvetica", fontSize: 10 },
      headStyles: { fillColor: [0, 159, 183] }, // your theme color
    });
  
    doc.save("ordini-contatti.pdf");
  };
  
  

useEffect(() => {
  axios
    .get("https://api.lidodavittorio.it/api/orders")
    .then((res) => {
      const pagatoOrders = res.data.filter((o) => o.stato === "pagato");
      setOrders(pagatoOrders);
      setFiltered(pagatoOrders);
    })
    .catch((err) => console.error("Errore nel caricamento ordini:", err));
}, []);


  useEffect(() => {
    let data = [...orders];

    if (filterPosto.trim()) {
      data = data.filter((o) =>
        o.posto.toLowerCase().includes(filterPosto.toLowerCase())
      );
    }

    if (filterDate) {
      data = data.filter((o) =>
        new Date(o.created_at).toISOString().startsWith(filterDate)
      );
    }

    setFiltered(data);
    setCurrentPage(1);
  }, [filterPosto, filterDate, orders]);

  const totalPages = Math.ceil(filtered.length / ITEMS_PER_PAGE);
  const paginatedOrders = filtered.slice(
    (currentPage - 1) * ITEMS_PER_PAGE,
    currentPage * ITEMS_PER_PAGE
  );

  const handlePageChange = (page) => {
    if (page >= 1 && page <= totalPages) setCurrentPage(page);
  };

  return (
    <div className="overflow-x-auto">
      {/* Title */}
      <h2 className="text-2xl font-bold font-[chivo] text-[#009FB7] mb-6">
        Riepilogo Ordini
      </h2>
      <div className="mb-4">
      <button
  onClick={exportToPDF}
  className="bg-[#009FB7] text-white px-4 py-2 rounded hover:bg-[#007d99] font-[chivo] flex items-center gap-2"
>
  <FaFilePdf className="text-lg text-red-200" />
  Esporta in PDF
</button>

</div>


      {/* Filters */}
      <div className="flex flex-col sm:flex-row gap-4 justify-between mb-6 font-[chivo]">
        <input
          type="text"
          placeholder="Filtra per Posto..."
          value={filterPosto}
          onChange={(e) => setFilterPosto(e.target.value)}
          className="border px-3 py-2 rounded w-full sm:w-1/2"
        />
        <input
          type="date"
          value={filterDate}
          onChange={(e) => setFilterDate(e.target.value)}
          className="border px-3 py-2 rounded w-full sm:w-1/2"
        />

        
      </div>

      {/* Table */}
      <table className="w-full border-collapse font-[chivo] text-sm sm:text-base mb-6">
      <thead>
  <tr className="bg-[#009FB7] text-white">
    <th className="p-3 border">ID</th>
    <th className="p-3 border">Posto</th>
    <th className="p-3 border">Stato</th>
    <th className="p-3 border">Completato</th>
    <th className="p-3 border">Totale</th>
    <th className="p-3 border">Ordine</th>
    <th className="p-3 border">Email</th>
    <th className="p-3 border">Telefono</th>
    <th className="p-3 border">Creato</th>
  </tr>
</thead>
<tbody>
  {paginatedOrders.map((order) => (
    <tr key={order.id} className="border-b hover:bg-gray-100">
      <td className="p-3">{order.id}</td>
      <td className="p-3">{order.posto}</td>
      <td className="p-3">
        <span
          className={`font-bold ${
            order.stato === "pagato" ? "text-green-600" : "text-red-600"
          }`}
        >
          {order.stato}
        </span>
      </td>
      <td className="p-3">
        <span
          className={`font-bold ${
            order.completato === "NO" ? "text-red-600" : "text-green-600"
          }`}
        >
          {order.completato}
        </span>
      </td>
      <td className="p-3 text-lg font-bold text-[#009FB7]">
        €{order.prezzo.toFixed(2)}
      </td>
<td className="p-3 text-left">
  {(() => {
    try {
      const ordineObj = JSON.parse(order.ordine);
      return Object.entries(ordineObj).map(([key, item], index) => {
        const category = key.split("-")[0];
        return (
          <div key={index} className="mb-1">
            <span className="font-bold text-[#009FB7] mr-2">[{category}]</span>
            <span>{item.qty} x {item.nome}</span>
          </div>
        );
      });
    } catch {
      return order.ordine;
    }
  })()}
</td>




      <td className="p-3">{order.email || "—"}</td>
      <td className="p-3">{order.phone || "—"}</td>
      <td className="p-3">
        {new Date(order.created_at).toLocaleString("it-IT", {
          timeZone: "Europe/Rome",
        })}
      </td>
    </tr>
  ))}
</tbody>

      </table>

      {/* Pagination Controls */}
      <div className="flex justify-center items-center gap-4 font-[chivo]">
        <button
          onClick={() => handlePageChange(currentPage - 1)}
          disabled={currentPage === 1}
          className="px-3 py-1 rounded bg-gray-200 hover:bg-gray-300 disabled:opacity-50"
        >
          ◀ Precedente
        </button>

        <span>
          Pagina <strong>{currentPage}</strong> di{" "}
          <strong>{totalPages}</strong>
        </span>

        <button
          onClick={() => handlePageChange(currentPage + 1)}
          disabled={currentPage === totalPages}
          className="px-3 py-1 rounded bg-gray-200 hover:bg-gray-300 disabled:opacity-50"
        >
          Prossimo ▶
        </button>
      </div>
    </div>
  );
};

export default OrdiniTable;
